var StatusWorkflowEnum = /* @__PURE__ */ ((StatusWorkflowEnum2) => {
  StatusWorkflowEnum2["completed"] = "completed";
  StatusWorkflowEnum2["failure"] = "failure";
  StatusWorkflowEnum2["queued"] = "queued";
  StatusWorkflowEnum2["aborted"] = "aborted";
  StatusWorkflowEnum2["inProgress"] = "in_progress";
  StatusWorkflowEnum2["skipped"] = "skipped";
  StatusWorkflowEnum2["canceled"] = "cancelled";
  StatusWorkflowEnum2["timeOut"] = "timed_out";
  StatusWorkflowEnum2["default"] = "default";
  StatusWorkflowEnum2["actionRequired"] = "action_required";
  StatusWorkflowEnum2["neutral"] = "neutral";
  StatusWorkflowEnum2["stale"] = "stale";
  StatusWorkflowEnum2["success"] = "success";
  StatusWorkflowEnum2["requested"] = "requested";
  StatusWorkflowEnum2["waiting"] = "waiting";
  StatusWorkflowEnum2["pending"] = "pending";
  return StatusWorkflowEnum2;
})(StatusWorkflowEnum || {});

export { StatusWorkflowEnum };
//# sourceMappingURL=WorkflowListEnum.esm.js.map
